// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3VPUW","info":"Note_info__3YrpY","note":"Note_note__3J-Md","actions":"Note_actions__BNRp4"};